//post api-update user details (update sign-up form)

const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL;
export const UpdateUserdetailsApi = async (
  userId: string,
  info: {
    firstname: string;
    lastname: string;
    phonenumber: number;
    email: string;
    password: string;
    role?: string;
  }
) => {
  const res = await fetch(
    `${BASE_URL}/usersignup/updateuserdetails/${userId}`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(info),
    }
  );

  const data = await res.json();
  if (!res.ok) {
    throw new Error(data.error || "User Updation failed");
  }
  return data;
};
//get api-fetch all users
export const fetchallUsersApi = async (page = 1, limit: number) => {
  try {
    const res = await fetch(
      `${BASE_URL}/usersignup?page=${page}&limit=${limit}`,
      {
        cache: "no-store",
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    );
    const results = await res.json();

    if (!res.ok) {
      throw new Error(results.error || "Failed to fetch user data");
    }
    return results;
  } catch (err) {
    console.error("Fetch API error:", err);
    throw err;
  }
};

//get api-Fetch single data of user
export const fetchUserById = async (userId: string) => {
  try {
    const res = await fetch(
      `${BASE_URL}/usersignup/updateuserdetails/${userId}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        cache: "no-store",
      }
    );
    if (!res.ok) {
      throw new Error("Failed to fetch user");
    }

    const data = await res.json();
    return data;
  } catch (error) {
    console.error("Error fetching single user", error);
    return null;
  }
};

// soft-delete api-for deleting the users
export const deleteUserApi = async (userId: string) => {
  try {
    const res = await fetch(
      `${BASE_URL}/usersignup/updateuserdetails/${userId}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    const result = await res.json();

    if (!res.ok) {
      throw new Error(result.error || "Failed to delete user");
    }

    return result;
  } catch (error) {
    console.error("Error deleting user:", error);
    throw error;
  }
};

// post api-Send OTP to user by email
export const sendOtpToUserApi = async ({ email }: { email: string }) => {
  try {
    const response = await fetch(`${BASE_URL}/signin/userotpgenerate`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    });

    const data = await response.json();
    if (!response.ok) {
      console.error("OTP send failed:", data.error);
      alert(`Failed to send OTP: ${data.error}`);
    } else {
      alert("OTP sent successfully! Please check your email.");
      return data;
    }
  } catch (error) {
    console.error("Error sending OTP:", error);
    alert("Error: Unable to send OTP");
  }
};

//post api for otp verification
export const userOtpVerification = async (otp: string) => {
  try {
    const res = await fetch(`${BASE_URL}/signin/userotpverification`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ otp }),
    });
    const data = await res.json();
    if (!res.ok) {
      throw new Error(data.error || "OTP verification failed");
    }
    return { success: true, message: data.message };
  } catch (error) {
    return { success: false, message: error.message };
  }
};

//post api-Reset user Password by email, otp and new password
export const resetUserPassword = async (
  email: string,
  otp: string,
  newpassword: string,
  confirmpassword: string
) => {
  try {
    const response = await fetch(`${BASE_URL}/signin/userforgetpass`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, otp, newpassword, confirmpassword }),
    });

    const data = await response.json();

    if (!response.ok) {
      console.error("Password reset failed:", data.error);
      alert(`Failed to reset password: ${data.error}`);
    } else {
      alert("Password reset successful!");
    }
  } catch (error) {
    console.error("Something went wrong while resetting password:", error);
    alert("Error: Unable to reset password");
  }
};

//post-api change password for user
export const changeUserPassword = async (
  email: string,
  oldpassword: string,
  newpassword: string,
  confirmpassword: string
) => {
  try {
    const res = await fetch(`${BASE_URL}/signin/userpasschange`, {
      method: "POST",
      headers: { "Content-Type": "applicaton/json" },
      body: JSON.stringify({
        email,
        oldpassword,
        newpassword,
        confirmpassword,
      }),
    });
    const data = await res.json();
    if (!res.ok) {
      console.error("Password change failed:", data.error);
    } else {
      return data;
    }
  } catch (err) {
    console.error("Something went wrong while changing password:", err);
  }
};
